import React, { useState } from 'react';
import PropTypes from 'prop-types';
import translate from '../../commonComponents/translate';
import { useScrollAnchor } from '../../services/customHooks';
import TextFilter from '../../commonComponents/lists/filters/TextFilter';
import MySessionList from './list/MySessionList';
import UserProp from '../../commonComponents/propTypes/userProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import User from '../../../../../domain/models/user';
import Checkbox from '../../commonComponents/forms/inputs/Checkbox';

function MySessions(props) {
  const {
    t,
    loggedUser,
    languages,
  } = props;

  const { contentElement, scrollToContent } = useScrollAnchor();
  const [query, setQuery] = useState({ search: '' });

  const handleQueryChange = value => {
    setQuery(prevState => ({ ...prevState, search: value }));
    scrollToContent();
  };

  // Gets the type of user logged, if he is a collaborator shows New Session Button
  const userType = loggedUser.type === 'collaborator';

  const handleCheckbox = (type, value) => {
    setQuery(prevQuery => ({ ...prevQuery, [type]: value ? loggedUser?._id : null }));
  };
  return (
    <>
      <div className="m-portlet m-portlet--rounded">
        <div className="row top-actions-sessions">
          <div className="action col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <TextFilter
              onChange={handleQueryChange}
              placeholder={t('search')}
              value={query.search}
            />
          </div>
          <div className="checkbox-container action col-lg-2 col-md-2 col-sm-2 col-xs-12">
            <Checkbox
              id="owner"
              name="owner"
              label={t('mySessions.filters.owner')}
              value={!!query.owner || false}
              onClick={({ currentTarget }) => {
                handleCheckbox('owner', currentTarget.checked);
              }}
              className="my-session-checkbox"
            />
          </div>
          <div className="checkbox-container action col-lg-2 col-md-2 col-sm-2 col-xs-12">
            <Checkbox
              id="trainer"
              name="trainer"
              label={t('mySessions.filters.trainer')}
              value={!!query.trainer || false}
              onClick={({ currentTarget }) => {
                handleCheckbox('trainer', currentTarget.checked);
              }}
              className="my-session-checkbox"
            />
          </div>
          <div className="checkbox-container action col-lg-2 col-md-2 col-sm-2 col-xs-12">
            <Checkbox
              id="host"
              name="host"
              label={t('mySessions.filters.host')}
              value={!!query.host || false}
              onClick={({ currentTarget }) => {
                handleCheckbox('host', currentTarget.checked);
              }}
              className="my-session-checkbox"
            />
          </div>
          { loggedUser && (userType || (loggedUser.role && loggedUser.role === User.ROLE.ADMIN)) &&
            <div className="action col-lg-2 col-md-2 col-sm-2">
              <a
                href="/academy/session/create"
                className="btn btn-brand btn-sm m-btn--pill"
              >
                {`+ ${t('sessions_newSession_button')}`}
              </a>
            </div>
          }
        </div>
      </div>
      <MySessionList loggedUser={loggedUser} query={query} languages={languages} />
    </>
  );
}

MySessions.propTypes = {
  t: PropTypes.func.isRequired,
  loggedUser: PropTypes.shape(UserProp.propType).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};

export default translate(MySessions);
